import React from 'react';
import Layout from '@/sections/Layout';

import Hero from '@/sections/pages/GasStations/Hero';
import Solutions from '@/sections/common/Solutions';
import Partners from '@/sections/common/Partners';
import Statistic from '@/sections/common/Statistic';
import Ecosystem from '@/sections/pages/GasStations/Ecosystem';
import Transactions from '@/sections/pages/GasStations/Transactions';
import Benefits from '@/sections/common/Benefits';
import Questions from '@/sections/pages/GasStations/Questions';
import Registration from '@/sections/common/Registration';
import News from '@/sections/common/News';

import QUESTIONS_DATA from '@/mocks/questions';
import NEWS_DATA from '@/mocks/storyNews';
import PARTNERS_DATA from '@/mocks/partners';
import BENEFITS_DATA from '@/mocks/benefits';

import '@/sections/pages/GasStations/styles.scss';

const HERO_LIST = [
  'All-in-one solution for all the BU’s — forecourt, convenience store, car wash, restaurant  and others',
  'Connection to all necessary peripheral components (dosing columns, price displays, tank content measurement systems, etc.) ',
  'Realtime sales reporting',
  'Dynamic price management',
];

const STATISTICS = [
  {
    number: '150000+',
    desc:
      'Transactions daily are made in through Cirrus  software for Gas stations',
  },
  {
    number: '99.9%',
    desc:
      'an average ‘work without interruption’ ratio for entire Cirrus platform',
  },
  {
    number: '2348',
    desc: 'POS’es all around the Switzerland and beyond are runnig Cirrus',
  },
];

const SOLUTIONS = {
  title: 'Operate gas stations efficiently in one comprehensive solution',
  suptitle: 'Trusted by our partners',
  list: [
    {
      icon: 'gas-station',
      title: 'Fuel management',
    },
    {
      icon: 'point-of-sale',
      title: 'Point of Sale',
    },
    {
      icon: 'cafe-restaurant',
      title: 'Cafe/Restaurant',
    },
    {
      icon: 'car-wash',
      title: 'Car wash management',
    },
    {
      icon: 'loyalty-marketing',
      title: 'Loyalty & marketing',
    },
  ],
};

const GasStations = () => (
  <Layout
    currentPageClass={'cr-gas-stat-page'}
    headerClass={'cr-gas-stat-header'}
    mainClass={'cr-gas-stat-main'}
    footerClass={'cr-gas-stat-footer'}
  >
    {(commonData) => (
      <>
        <section className="cr-gas-stat__hero">
          <Hero list={HERO_LIST} />
        </section>

        <section className="cr-wrap cr-gas-stat__solutions">
          <Solutions {...SOLUTIONS} />
        </section>

        <section className="cr-wrap cr-gas-stat__partners">
          <Partners partners={PARTNERS_DATA} />
        </section>

        <section className="cr-wrap cr-gas-stat__stat">
          <Statistic list={STATISTICS} />
        </section>

        <section className="cr-gas-stat__ecosystem">
          <Ecosystem />
        </section>

        <section className="cr-wrap cr-gas-stat__trans">
          <Transactions />
        </section>

        <section className="cr-wrap cr-gas-stat__benefits">
          <Benefits benefits={BENEFITS_DATA} />
        </section>

        <section className="cr-gas-stat__questions">
          <Questions questions={QUESTIONS_DATA} />
        </section>

        <section className="cr-wrap cr-gas-stat__registr">
          <Registration />
        </section>

        <section className="cr-wrap cr-gas-stat__news">
          <News news={NEWS_DATA} />
        </section>
      </>
    )}
  </Layout>
);

export default GasStations;
